<template>
  <div class="dashboard-container">
    <div class="dashboard-header">
      <div class="dashboard-title">
        <!-- <h1>Notificaciones</h1> -->
      </div>
      <div class="dashboard-actions">
        <button class="add-btn" @click="showAddModal = true">
          <i class="fas fa-plus"></i>
          Agregar Notificación
        </button>
      </div>
    </div>
    <div class="search-container">
      <i class="fas fa-search search-icon"></i>
      <input
        v-model="search"
        @focus="dropdownOpen = true"
        @input="dropdownOpen = true"
        @blur="closeDropdown"
        type="text"
        class="search-input"
        placeholder="Buscar expediente..."
        autocomplete="off"
      />
      <ul v-if="dropdownOpen && filteredProceedings.length" class="dropdown-menu show w-100 mt-1">
        <li v-for="p in filteredProceedings" :key="p.id">
          <a href="#" class="dropdown-item" @mousedown.prevent="selectProceeding(p)">
            {{ p.number }} - {{ p.title || p.description || 'Sin título' }}
          </a>
        </li>
      </ul>
    </div>
    <div v-if="selectedProceeding">
      <h2 class="mb-3">Expediente: {{ selectedProceeding.number }}</h2>
      <div class="table-container">
        <table v-if="notifications.length > 0" class="proceedings-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Notificación</th>
              <th>Descripción</th>
              <th>Activa</th>
              <th>Programada a</th>
              <th>Siguiente Ejecución</th>
              <th>Notificado?</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="notification in notifications" :key="notification.id">
              <td>{{ notification.id }}</td>
              <td>{{ notification.name }}</td>
              <td>{{ notification.description }}</td>
              <td>
                <span :class="{'badge bg-success': notification.active, 'badge bg-danger': !notification.active}">
                  {{ notification.active ? 'Sí' : 'No' }}
                </span>
              </td>
              <td>{{ formatDate(notification.scheduled_time).split(",")[1] }}</td>
              <td>{{ nextExcution(notification.scheduled_time) }}</td>
              <td>{{ taskStatus(notification.task_status) }}</td>
              <td>
                <button class="table-btn edit-btn" @click="openEditModal(notification)" aria-label="Editar" data-bs-toggle="tooltip" title="Editar">
                  <i class="fas fa-edit" aria-label="Editar"></i>
                </button>
                <button class="table-btn delete-btn" @click="confirmDelete(notification.id)" aria-label="Eliminar" data-bs-toggle="tooltip" title="Eliminar">
                  <i class="fas fa-trash" aria-label="Eliminar"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <p v-if="notifications.length === 0" class="empty-state">No hay notificaciones para este expediente.</p>
      </div>
      <!-- Add Notification Modal -->
      <AddNotificationModal
        v-if="showAddModal"
        :proceeding-id="selectedProceeding.id"
        @close="showAddModal = false"
        @saved="onNotificationSaved"
      />
      <!-- Edit Notification Modal -->
      <EditNotificationModal
        v-if="showEditModal"
        :notification="editingNotification"
        :proceeding-id="selectedProceeding.id"
        @close="closeEditModal"
        @saved="onNotificationSaved"
      />
    </div>
    <div v-else class="empty-state">
      <div class="empty-state-icon">
        <i class="fas fa-bell"></i>
      </div>
      <h3>Seleccione un expediente para ver sus notificaciones.</h3>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AddNotificationModal from '../components/AddNotificationModal.vue';
import EditNotificationModal from '../components/EditNotificationModal.vue';
export default {
  name: 'ModernNotificationView',
  components: {
    AddNotificationModal,
    EditNotificationModal, 
  },
  data() {
    return {
      search: '',
      dropdownOpen: false,
      selectedProceeding: null,
      showAddModal: false,
      showEditModal: false,
      editingNotification: null,
    };
  },
  computed: {
    ...mapGetters({
      notifications: 'stateNotifications',
      allProceedings: 'stateProceedings',
    }),
    filteredProceedings() {
      if (!this.search) return this.allProceedings;
      const s = this.search.toLowerCase();
      return this.allProceedings.filter(p =>
        (p.number && p.number.toLowerCase().includes(s)) ||
        (p.title && p.title.toLowerCase().includes(s)) ||
        (p.description && p.description.toLowerCase().includes(s))
      );
    },
  },
  methods: {
    ...mapActions(['getNotifications', 'getProceedings', 'viewProceeding']),
    async fetchNotifications(proceedingId) {
      await this.getNotifications(proceedingId);
    },
    selectProceeding(p) {
      this.selectedProceeding = p;
      this.search = p.number;
      this.dropdownOpen = false;
      this.fetchNotifications(p.id);
    },
    closeDropdown() {
      setTimeout(() => {
        this.dropdownOpen = false;
      }, 150);
    },
    formatDate(time) {
      const date = new Date('2000-01-01 ' + time);
      const today = new Date();
      date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
      return date.toLocaleString('es-MX');
    },
    nextExcution(time) {
      const date = new Date('2000-01-01 ' + time);
      const today = new Date();
      date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate() + 1);
      return date.toLocaleString('es-MX');
    },
    taskStatus(task_status) {
      switch (task_status) {
        case 'scheduled':
          return 'Programado';
        case 'email_sent':
          return 'Notificado';
        default:
          return 'Por Programar';
      }
    },
    async confirmDelete(id) {
      if (confirm('¿Estás seguro de eliminar esta notificación?')) {
        await this.$store.dispatch('deleteNotification', id);
        if (this.selectedProceeding) {
          this.fetchNotifications(this.selectedProceeding.id);
        }
      }
    },
    openEditModal(notification) {
      this.editingNotification = notification;
      this.showEditModal = true;
    },
    closeEditModal() {
      this.showEditModal = false;
      this.editingNotification = null;
    },
    onNotificationSaved() {
      if (this.selectedProceeding) {
        this.fetchNotifications(this.selectedProceeding.id);
      }
      this.showAddModal = false;
      this.closeEditModal();
    },
  },
  async created() {
    await this.getProceedings(this.$store.state.users.user);
  },
};
</script>

<style scoped>
.dashboard-container {
  max-width: 1100px;
  margin: 2.5rem auto;
  padding: 2rem 1.5rem;
  background: #f6f6f8;
  border-radius: 24px;
  min-height: 600px;
  box-shadow: 0 2px 16px 0 rgba(0,0,0,0.04);
  border: 2px solid var(--primary);
}
.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
.dashboard-title h1 {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
  color: var(--primary);
}
.dashboard-actions {
  display: flex;
  gap: 1rem;
}
.add-btn {
  background: var(--primary);
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 0.5rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.add-btn:hover {
  background: var(--primary-dark);
}
.search-container {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  padding: 0.5rem 1rem;
  margin-bottom: 2rem;
  box-shadow: 0 1px 4px 0 rgba(0,0,0,0.04);
}
.search-icon {
  color: var(--primary);
  margin-right: 0.7rem;
}
.search-input {
  border: none;
  outline: none;
  font-size: 1rem;
  background: transparent;
  flex: 1;
}
.table-container {
  margin-top: 2rem;
}
.proceedings-table {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 4px 0 rgba(0,0,0,0.04);
}
.proceedings-table th, .proceedings-table td {
  padding: 1rem 0.7rem;
  text-align: left;
}
.proceedings-table th {
  background: var(--primary);
  color: #fff;
  font-weight: 700;
}
.notification-badge {
  background: var(--primary);
  color: #fff;
  border-radius: 12px;
  padding: 0.2rem 0.7rem;
  font-size: 0.95rem;
  font-weight: 600;
}
.table-btn {
  background: #fff;
  color: var(--primary);
  border: 2px solid var(--primary);
  border-radius: 20px;
  padding: 0.3rem 1rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  margin-right: 0.5rem;
  transition: background 0.2s, color 0.2s;
}
.table-btn:hover {
  background: #f3eaff;
  color: var(--primary-dark);
}
.edit-btn {
  border-color: #ffc107;
  color: #ffc107;
}
.edit-btn:hover {
  background: #fffbe6;
  color: #b38600;
}
.delete-btn {
  border-color: #dc3545;
  color: #dc3545;
}
.delete-btn:hover {
  background: #ffeaea;
  color: #a71d2a;
}
.empty-state {
  text-align: center;
  margin-top: 4rem;
}
.empty-state-icon {
  font-size: 3rem;
  color: var(--primary);
  margin-bottom: 1rem;
}
.empty-state-btn {
  background: var(--primary);
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 0.7rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  margin-top: 1.5rem;
  cursor: pointer;
  transition: background 0.2s;
}
.empty-state-btn:hover {
  background: var(--primary-dark);
}
.pagination-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 2rem;
}
.pagination-btn {
  background: #fff;
  color: var(--primary);
  border: 2px solid var(--primary);
  border-radius: 20px;
  padding: 0.3rem 1rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.pagination-btn:hover:not(:disabled) {
  background: #f3eaff;
  color: var(--primary-dark);
}
.pagination-info {
  font-size: 1rem;
  color: #222;
}
@media (max-width: 900px) {
  .dashboard-container {
    padding: 1.5rem 0.5rem;
  }
  .dashboard-header {
    flex-direction: column;
    gap: 1.2rem;
    align-items: flex-start;
  }
}
/* Modal backdrop fix for transparency */
.modal-backdrop {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.25) !important;
  z-index: 2000 !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
